export default {"src":"/_next/static/media/hero.7786cd5c.svg","height":745,"width":1050};